import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Company } from 'utils/types';

import c from '../utils/constants';
import contactDetailsTransformer from '../transformers/contactDetailsTransformer';

export default function useGetCompanyContactDetails(id: string, params = {}) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useQuery<Company, ApiError>({
    queryKey: [c.COMPANIES, id, c.DETAILS],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: `api/v1/contacts/companies/${id}`,
            params,
            transformer: contactDetailsTransformer.companyContactDetails,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/contacts/companies/${id}`,
            params,
            transformer: contactDetailsTransformer.companyContactDetails,
          },
        }),
      );

      return data?.data;
    },
    enabled: !!id,
    retry: 1,
  });
}
